"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxCallError = ajaxCallError;
exports.beginAjaxCall = beginAjaxCall;
exports.beginAjaxLoad = beginAjaxLoad;
exports.configuratorLoad = configuratorLoad;
exports.configuratorLoadFailure = configuratorLoadFailure;
exports.configuratorLoadSuccess = configuratorLoadSuccess;
exports.endAjaxLoad = endAjaxLoad;
var _actionTypes = require("./actionTypes");
function beginAjaxCall() {
  return {
    type: _actionTypes.BEGIN_AJAX_CALL
  };
}
function ajaxCallError() {
  return {
    type: _actionTypes.AJAX_CALL_ERROR
  };
}
function beginAjaxLoad(loadingMessage) {
  var isLongLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: _actionTypes.BEGIN_AJAX_LOAD,
    loadingMessage: loadingMessage,
    isLongLoad: isLongLoad
  };
}
function endAjaxLoad() {
  return {
    type: _actionTypes.END_AJAX_LOAD
  };
}
function configuratorLoad() {
  return {
    type: _actionTypes.CONFIGURATOR_LOAD
  };
}
function configuratorLoadSuccess() {
  return {
    type: _actionTypes.CONFIGURATOR_LOAD_SUCCESS
  };
}
function configuratorLoadFailure() {
  return {
    type: _actionTypes.CONFIGURATOR_LOAD_FAILURE
  };
}
//# sourceMappingURL=ajaxStatusActions.js.map